import { useSelector } from "react-redux";

import { RootState } from "@/store/store";
import Title from "@/shared/components/Title/Title";
import { TextField } from "@mui/material";
import PatientsHeaderSelector from "../PatientsHeader/PatientsHeaderSelector";
import { inputStyles, inputSearchInHeader } from "@/utils/constants";

import { IPatientsProps } from "@/shared/interfaces/patientPage";

export default function UsersHeader({
    handleChange,
    query,
    toggleDrawer,
    handleChangeSortOpton,
    sortOption,
}: IPatientsProps) {
    const dataLength = useSelector((state: RootState) => state.data.dataLength);
    return (
        <header className='header_in_content_component header_in_patiens_page'>
            <Title tag='h2' text={"Користувачі"} />
            <Title
                tag='h3'
                text={`(${dataLength.toString()})`}
                style={{
                    color: "#909DAD",
                }}
            />
            <div className='header_input_container'>
                <img
                    src='/patients/search.svg'
                    alt='logo search'
                    className='header_input_container_logo'
                />
                <TextField
                    placeholder='Пошук'
                    value={query}
                    onChange={handleChange}
                    sx={{
                        ...inputStyles.root,
                        ...inputSearchInHeader.root,
                    }}
                />
                <PatientsHeaderSelector
                    handleChangeSortOpton={handleChangeSortOpton}
                    sortOption={sortOption}
                />
            </div>
            <button
                className='header_input_add_button'
                onClick={() => toggleDrawer(true)}
            >
                <img src='/patients/plus.svg' alt='logo plus' />
                Додати користувача
            </button>
        </header>
    );
}
